import { IApplicationContext } from "../ApplicationContext";
import { FmsSubMenu } from "../constants/fmsSubMenu";
import { ArrivalNoticeArgs, AuthEntryArgs, AWBArgs, BookConfirmArgs, BookingAIFGArgs, CarrierCertArgs, CheckSubArgs, ChkMessengerArgs, 
  CRDBArgs, 
  DockReceiptArgs, ExdectransitArgs, FreightANArgs, InvoiceArgs, ISFHistoryArgs, IssueReadyArgs, LabelFolderArgs, ManifestArgs, MasterSetArgs, 
  NewProfitArgs, OEUSDAArgs, OIHouseBLArgs, OutStateArgs, PickSlipArgs, SecondANArgs, TelexReleaseArgs, TSAArgs, WarehouseReceiptArgs, WhseLabelRcptArgs, 
  WhseLabelShipArgs } from "../fms.report/args";
import { DocumentType } from "../framework.core/DocumentType";
import { getTbNameByJobName, JobNames } from "../framework.core/JobNames";
import _ from "lodash";
import { getFmsGlobal } from "../globals";

export async function getSelectedSubMenuArgs(fmsSubMenu: FmsSubMenu, jobName: JobNames, selectedElement: any, appContext: IApplicationContext, showGlobalYesNoDialog: any, showGlobalOkDialog: any){
  // let columnName;
  // let operationList = true;
  let blNo = "";
  let blFName = "";
  
  switch (jobName)
  {
      case JobNames.OIMbl:
      case JobNames.OEMbl:
      case JobNames.OtherOP:
      case JobNames.WHRcpt:
        blNo = selectedElement.refNo??'';     // Ref No
        break;
      case JobNames.OIHbl:
      case JobNames.OEHbl:
      case JobNames.OEBook:
      case JobNames.AMSHouse:  
        blNo = selectedElement.hblNo??'';
        break;
      case JobNames.AIMbl:
      case JobNames.AEMbl:  
        blNo = selectedElement.mawbNo??'';    // MblNo
        break;
      case JobNames.AIHbl:
      case JobNames.AEHbl:
        blNo = selectedElement.hawbNo??'';
        break;
      case JobNames.WHRcv:
        blNo = selectedElement.receiveNo??'';
        break;
      case JobNames.WHShip:
        blNo = selectedElement.shipNo??'';
        break;
      case JobNames.ISF:
        blNo = selectedElement.isfNo??'';
        break;
      case JobNames.AMSMaster:
        blNo = selectedElement.mblNo??'';
        break;
      case JobNames.ACIManifest:
        blNo = selectedElement.houseBill??'';     // HouseBill
        break;
      default:
        blNo = "";
        break;
  }

  let args;
  let title;
  let blType;
  let aoType;
  let airOcean;
  let blName;
  let importExport;
  let deptName;
  let docType;
  let toCompanyid;
  let doConfirm;

  const tbId = selectedElement?.id?.toString()||'0';
  const tbName = getTbNameByJobName(jobName)?.toUpperCase()||'';
  const fmsGlobal = getFmsGlobal();

  switch (tbName){
    case "T_GENMAIN":
      blFName = `[REF#${blNo}]`;
      deptName = "OT";
      break;
    case "T_INVENHD":
      blFName = `[REF#${blNo}]`;
      break;
    default:
      if(tbName){
        blType = tbName.substring(4,5);   // M, H
        aoType = tbName.substring(2,3);   // A, O
        airOcean = aoType === "A" ? "Air" : "Ocean";
        blName = aoType === "A" ? "AWB" : "BL";
        importExport = tbName.substring(3,4) === "I" ? "Import" : "Export";
        //deptName = `${airOcean} ${importExport}`;
        deptName = tbName.substring(2,4);
        blFName = `[${blType}${blName}#${blNo}]`;
      }
      break;
  }
  switch(fmsSubMenu){
    case FmsSubMenu.MasterProfit:

      //check user security
      if(fmsGlobal.NoProfitShow){
        showGlobalOkDialog('Contact Manager!');
        return false;
      }

      if(tbName){
        title = `Estimated Profit Report ${blFName}`;
        args = new NewProfitArgs({
          docType: DocumentType.Profit,
          formCaption: title,
          subject: title,
    
          reportType: "MG",
          departments: deptName,
          groupFieldName: "F_RefNo",
          viewType: "D",
          sortFieldNum: 0,
          tbId,
          tbName,
        })
      }
      break;
    case FmsSubMenu.MasterProfitHBL:
      
      //check user security
      if(fmsGlobal.NoProfitShow){
        showGlobalOkDialog('Contact Manager!');
        return false;
      }

      if(tbName){
        title = `Recog Profit Report ${blFName}`;
        args = new NewProfitArgs({
          docType: DocumentType.Profit,
          formCaption: title,
          subject: title,
    
          reportType: "GP",
          groupFieldName: "F_RefNo",
          viewType: "D",
          sortFieldNum: 0,
          tbId,
          tbName,
          departments: deptName,
          dataBLName: tbName,
        })
      }
      break;
    case FmsSubMenu.OICargoManifest:
    case FmsSubMenu.OOCargoManifest:
    case FmsSubMenu.AICargoManifest:
    case FmsSubMenu.AOCargoManifest:
      title = `${airOcean} ${importExport} Cargo Manifest ${blFName}`;
      
      if(fmsSubMenu === FmsSubMenu.OICargoManifest){
        docType = DocumentType.OI_CargoManifest
      }else if(fmsSubMenu === FmsSubMenu.OOCargoManifest){
        docType = DocumentType.OO_CargoManifest
      }else if(fmsSubMenu === FmsSubMenu.AICargoManifest){
        docType = DocumentType.AI_CargoManifest
      }else if(fmsSubMenu === FmsSubMenu.AOCargoManifest){
        docType = DocumentType.AO_CargoManifest
      }

      args = new ManifestArgs({
        docType,
        formCaption: title,
        subject: title,
  
        toCompanyid: selectedElement.agentId?.toString(),
        tbId,
        tbName,
      })
      break;
    case FmsSubMenu.FolderLabel:
      // #1765 - FMS5의 경우 Direct Print 기능이 없기 때문에 Confirm Msg를 표시할 필요가 없음
      // doConfirm = await showGlobalYesNoDialog(
      //   <div>
      //     <h3>Confirm to Print?</h3>
      //     <p>Is your Folder Label printer ready?  Click YES to print.</p>
      //   </div>
      // );

      // if(doConfirm){
        title = `FOLDER LABEL ${blFName}`;
        args = new LabelFolderArgs({
          docType: DocumentType.LabelFolder,
          formCaption: title,
          subject: title,
    
          tbId,
          tbName,
        })
      // }else{
      //   return;
      // }
      break;
    case FmsSubMenu.OutOfStateLog:
      title = `Out Of State Log Sheet ${blFName}`;
      args = new OutStateArgs({
        docType: DocumentType.OutofStateLogSheet,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
      })
      break;
      case FmsSubMenu.ArrivalNotice:
      toCompanyid = `${await appContext.api.getRList(tbId, tbName, "F_Customer, F_Consignee, F_Notify")}${await appContext.api.getBrokerEmailFax(aoType, parseInt(tbId))}`;
      title = 'ARRIVAL NOTICE/FREIGHT INVOICE';
      args = new ArrivalNoticeArgs({
        docType: DocumentType.ArrivalNotice,
        formCaption: title,
        subject: title,      
        useMultiCur: appContext.suntekSettings?.accounting?.showAmountByCurrencyInInvoice,
        showCharge : '1',

        tbId,
        tbName,
        toCompanyid,
        
        newDesignForm: appContext.systemSettings?.useNewANReport ?? false,
        useUserContact : appContext.suntekSettings?.general?.useUserContact ??false,
      })
      break;
    case FmsSubMenu._2ndArrivalNotice:
      toCompanyid = `${await appContext.api.getRList(tbId, tbName, "F_Customer, F_Consignee, F_Notify")}${await appContext.api.getBrokerEmailFax(aoType, parseInt(tbId))}`;
      title = `${airOcean} 2nd Arrival Notice ${blFName}`;
      args = new SecondANArgs({
        docType: DocumentType.SecondAN,
        formCaption: title,
        subject: title,

        tbId,
        tbName,
        type: '2ND ARRIVAL NOTICE',
        toCompanyid,
      })
      break;
    case FmsSubMenu.WorkSheet:
      toCompanyid = `${await appContext.api.getRList(tbId, tbName, "F_Customer, F_Consignee, F_Notify")}${await appContext.api.getBrokerEmailFax(aoType, parseInt(tbId))}`;
      title = `WORK SHEET ${blFName}`;
      args = new SecondANArgs({
        docType: DocumentType.SecondAN,
        formCaption: title,
        subject: title,

        tbId,
        tbName,
        type: 'WORK SHEET',
        toCompanyid,
      })
      break;
    case FmsSubMenu.OIHouseBL:
      if (tbName) {
        title = `Ocean Import BL [HBL# ${blNo}]`;
        args = new OIHouseBLArgs({
          docType: DocumentType.OIHouseBl,
          formCaption: title,
          subject: title,
    
          tbId,
          tbName,
          houseBLNo: blNo,
          branch: appContext.user?.branch||''
        })
      }
      break;
    case FmsSubMenu.HouseProfit:
      
      //check user security
      if(fmsGlobal.NoProfitShow){
        showGlobalOkDialog('Contact Manager!');
        return false;
      }
      
      if(tbName){
        title = `Estimated Profit Report ${blFName}`;
        args = new NewProfitArgs({
          docType: DocumentType.Profit,
          formCaption: title,
          subject: title,
    
          reportType: "MG",
          departments: deptName,
          groupFieldName: "F_HBLNo",
          viewType: "D",
          tbId,
          tbName,
        })
      }
      break;
    case FmsSubMenu.CarrierCertificate:
      toCompanyid = `${await appContext.api.getRList(tbId, tbName, "F_Customer, F_Consignee, F_Notify")}${await appContext.api.getBrokerEmailFax(aoType, parseInt(tbId))}`;
      title = `${airOcean} Carrier Certificate ${blFName}`;
      args = new CarrierCertArgs({
        docType: DocumentType.CarrierCert,
        formCaption: title,
        subject: title,
        
        tbId,
        tbName,
      })
      break;
    case FmsSubMenu.ExdecTransit:
      title = `Exdec Transit ${blFName}`;
      args = new ExdectransitArgs({
        docType: DocumentType.Exdectransit,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
      })
      break;
    case FmsSubMenu.DockReceipt:
      toCompanyid = `${await appContext.api.getRList(tbId, tbName, "f_shipper")}`;
      title = `DOCK RECEIPT ${blFName}`;
      args = new DockReceiptArgs({
        docType: DocumentType.DockReceipt,
        formCaption: title,
        subject: title,
        
        toCompanyid,
        tbId,
        tbName,
        newDesignForm: appContext.systemSettings?.useNewDockReceiptReport ?? false,
      })
      break;
    case FmsSubMenu.MasterSet:
      title = `Master Set / Shipping Request ${blFName}`;
      args = new MasterSetArgs({
        docType: DocumentType.MasterSet,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
      })
      break;
    case FmsSubMenu.TelexReleaseMessage:
      title = `Telex Release Message ${blFName}`;
      args = new TelexReleaseArgs({
        docType: DocumentType.TelexRelease,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
      })
      break;
    case FmsSubMenu.OOHBook:
      title = `Booking Confirmation`;
      title += _.isEmpty(selectedElement.hBookingNo) ? '' : ` House Booking # ${selectedElement.hBookingNo}`;
      title += _.isEmpty(selectedElement.cBookingNo) ? '' : ` Carrier Booking # ${selectedElement.cBookingNo}`;
      if (appContext.suntekSettings?.company?.country !== "U.S." && appContext.suntekSettings?.company?.country === "GERMANY") {  //fmsGlobal.MSetup?.isIntnl -> appContext.suntekSettings?.company?.country !== "U.S." : 동일
        args = new BookingAIFGArgs({
          docType: DocumentType.OOHBookAIFG,
          formCaption: title,
          subject: title,
    
          tbId,
        });
      }else{
        args = new BookConfirmArgs({
          docType: DocumentType.OOHBook,
          formCaption: title,
          subject: title,
    
          tbId, 
          tbName,
          useUserContact : appContext.suntekSettings?.general?.useUserContact ??false,
        });
      }
      break;
    case FmsSubMenu.OEUSDA:
      title = "USDA Heat Treatment";
      args = new OEUSDAArgs({
        docType: DocumentType.OEUSDA,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
      });
      break;
    case FmsSubMenu.AuthEntry:
      toCompanyid = `${await appContext.api.getRList(tbId, tbName, "F_Customer, F_Consignee, F_Notify")}${await appContext.api.getBrokerEmailFax(aoType, parseInt(tbId))}`;
      title = `Authority to Make Entry ${blFName}`;
      args = new AuthEntryArgs({
        docType: DocumentType.AuthEntry,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
        toCompanyid,
      });
      break;
    // <jhlee 250722 - IAC Certificate 메뉴로 이동할 때 Date를 선택할 수 있는 옵션을 추가로 인해 사용 안함 />
    // case FmsSubMenu.TsaSecurity:
    //   title = "TSA Security Endorsement";
    //   args = new TSAArgs({
    //     docType: DocumentType.TSASecurity,
    //     formCaption: title,
    //     subject: title,
  
    //     tbId,
    //     tbName,
    //     branch: appContext.user?.branch||''
    //   });
    //   break;
    // case FmsSubMenu.TsaUnknown:
    //   title = "TSA Unknown";
    //   args = new TSAArgs({
    //     docType: DocumentType.TSAUnknown,
    //     formCaption: title,
    //     subject: title,
  
    //     tbId,
    //     tbName,
    //     branch: appContext.user?.branch||''
    //   });
    //   break;
    case FmsSubMenu.WReceipt:
      title = `Warehouse Receipt ${blFName}`;
      args = new WarehouseReceiptArgs({
        docType: DocumentType.WarehouseReceipt,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
      });
      break;
    case FmsSubMenu.WLabelReceive:
      // #1765 - FMS5의 경우 Direct Print 기능이 없기 때문에 Confirm Msg를 표시할 필요가 없음
      // doConfirm = await showGlobalYesNoDialog(
      //   <div>
      //     <h3>Confirm to Print?</h3>
      //     <p>Is your Label printer ready?  Click YES to print.</p>
      //   </div>
      // );
      // if(doConfirm){
        title = `Warehouse Receiving Label${blFName}`;
        args = new WhseLabelRcptArgs({
          docType: DocumentType.WhseLabelReceive,
          formCaption: title,
          subject: title,
    
          tbId,
          tbName,
        });
      // }
      break;
    case FmsSubMenu.WShip:
      title = `Pick Slip ${blFName}`;
      args = new PickSlipArgs({
        docType: DocumentType.PickSlip,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
      });
      break;
    case FmsSubMenu.WLabelShip:
      // #1765 - FMS5의 경우 Direct Print 기능이 없기 때문에 Confirm Msg를 표시할 필요가 없음
      // doConfirm = await showGlobalYesNoDialog(
      //   <div>
      //     <h3>Confirm to Print?</h3>
      //     <p>Is your Label printer ready?  Click YES to print.</p>
      //   </div>
      // );

      // if(doConfirm){
        title = `Warehouse Shipping Label${blFName}`;
        args = new WhseLabelShipArgs({
          docType: DocumentType.WhseLabelShip,
          formCaption: title,
          subject: title,
    
          tbId,
          tbName,
        });
      // }
      break;
    case FmsSubMenu.FArrivalNotice:
      title = `FREIGHT ARRIVAL NOTICE ${blFName}`;
      args = new FreightANArgs({
        docType: DocumentType.FreightAN,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
        toCompanyid: selectedElement?.shipper.toString()||'',
      });
      break;
    case FmsSubMenu.Invoice:
      title = `Invoice [${selectedElement?.invoiceNo}] for ${selectedElement?.invoiceToFName}`;
      args = new InvoiceArgs({
        docType: DocumentType.Invoice,
        formCaption: title,
        subject: title,

        tbId,
        tbName,
        stamp: appContext.suntekSettings?.accounting?.showPastDueOnInv,
        useMultiCur: appContext.suntekSettings?.accounting?.showCurAmountInInv, 
        toCompanyid: selectedElement?.invoiceTo.toString(),
        newDesignForm: appContext.systemSettings?.useNewInvoiceReport ?? false,
      });
      break;
    case FmsSubMenu.CrDbNote:
      title = `Cr/Db Note [CrDb #: ${selectedElement?.crDbNo}][Ref. #: ${selectedElement.refNo}]`;
      args = new CRDBArgs({
        docType: DocumentType.CRDB,
        formCaption: title,
        subject: title,
  
        tbId,
        tbName,
        toCompanyid: selectedElement?.agentId.toString(),
        newDesignForm: appContext.systemSettings?.useNewCrDbReport ?? false,
      });
      break;

    case FmsSubMenu.PuInvoice:
      title = `P/U Invoice [${selectedElement?.invoiceNo}] for ${selectedElement?.invoiceToFName}`;
      args = new InvoiceArgs({
        docType: DocumentType.PuInvoice,
        formCaption: title,
        subject: title,

        tbId,
        tbName,
        stamp: appContext.suntekSettings?.accounting?.showPastDueOnInv,
        useMultiCur: appContext.suntekSettings?.accounting?.showCurAmountInInv,
        toCompanyid: selectedElement?.invoiceTo.toString(),
        newDesignForm: appContext.systemSettings?.useNewInvoiceReport ?? false,
      });
      break;
    case FmsSubMenu.PrintCheckSlip:
      title = `Check Slip [${selectedElement?.vendor}]`;
      args = new CheckSubArgs({
        docType: DocumentType.CheckSub,
        formCaption: title,
        subject: title,

        tbId,
        tbName
      });
      break;
    case FmsSubMenu.PrintMessengerSlip:
      title = `Messenger Slip for Check [${selectedElement?.vendor}]`;
      args = new ChkMessengerArgs({
        docType: DocumentType.ChkMessenger,
        formCaption: title,
        subject: title,

        tbId,
        tbName
      });
      break;
    case FmsSubMenu.CompanyProfile:
      title = "Print Customer Profile";
      args = new ChkMessengerArgs({
        docType: DocumentType.CompanyProfile,
        formCaption: title,
        subject: title,
        
        tbId,
        tbName
      });
      break;
    case FmsSubMenu.AIAWB:
      title = `Air Way BL #${blNo}`;
      args = new AWBArgs({
        docType: DocumentType.AWB,
        formCaption: title,
        subject: title,
        tbId,
        tbName,
        orgCpy: "C",
        forUse: "B",
      });
      break;
    case FmsSubMenu.IsfDetail:
      title = `ISF History [${selectedElement?.hblNo}]`;
      args = new ISFHistoryArgs({
        docType: DocumentType.ISFHistory,
        formCaption: title,
        subject: title,
        jobId: selectedElement?.id ?? 0,
        isfNo: selectedElement?.isfNo
      });
      break;
  }

  return args;
}
